<div class="p-lr-30 p-t-20">
  <mat-accordion class="test border-accordion w-p-100">
    <mat-expansion-panel *ngIf="newsCount.pairwiseNewsCount > 0" [expanded]="true">
      <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
      Tax Treaties between {{country1.name}} and {{country2.name}} ({{newsCount.pairwiseNewsCount}})
      </mat-expansion-panel-header>

      <ng-template matExpansionPanelContent>

        <particle-treaty-news-viewer [id] = "id">

        </particle-treaty-news-viewer>

      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="newsCount.firstCountryNewsCount > 0">
      <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
        <b>Other {{country1.name}} Tax Treaty News ({{newsCount.firstCountryNewsCount}})</b>
      </mat-expansion-panel-header>

      <ng-template matExpansionPanelContent>

        <particle-treaty-news-viewer [id] = null [id1] = "id1" [id2]="id2">

        </particle-treaty-news-viewer>

      </ng-template>
    </mat-expansion-panel>

    <mat-expansion-panel *ngIf="newsCount.secondCountryNewsCount > 0">
      <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">
        <b>Other {{country2.name}} Tax Treaty News ({{newsCount.secondCountryNewsCount}})</b>
      </mat-expansion-panel-header >

      <ng-template matExpansionPanelContent>

        <particle-treaty-news-viewer [id] = null [id1] = "id2" [id2]="id1">

        </particle-treaty-news-viewer>

      </ng-template>
    </mat-expansion-panel>
  </mat-accordion>
</div>
